import React, {useContext} from "react";
import {Image, Space} from 'antd';
import cx from 'classnames';
import {Element} from "react-scroll";
import JobLeftMobile from "@/page-components/detail/Job/job_left_mobile";
import Ad from "@/page-components/detail/Ad";
import Plan from "@/page-components/detail/Plan";
import Data from "@/page-components/detail/data";
import Qa from "@/page-components/detail/Qa";
import {TExamDetailFixedDataType} from "@/types";
import JobList from "@/components/JobList";
import {Media} from "@/constants/media_query";
import PhoneComponentWrapper from "@/components/PhoneComponentWrapper/index";
import {DetailContext} from "@/context/detailContext";
import styles from './styles.module.less';

type TJob = {
  data: TExamDetailFixedDataType
}


const Job: React.FC<TJob> = ({data}) => {
  const contextProps = useContext(DetailContext);
  const {isAddExtraHeight, data: {extraTips}} = contextProps;
  const replaceBr = (str: string) => {
    return str.replace(/\n/g, '<br />')
  }
  return (
    <div className={styles.job}>
      <div className={styles.job_area}>
        <Media greaterThanOrEqual="md">
          <div className={styles.job_area_left}>
            {extraTips && (
                <div className={styles.extra_tips_wrapper}>
                  <a target="_blank" href={extraTips.href} rel="noreferrer">
                    <Space className={styles.extra_tips}>
                      <img alt="" src="/img/icon-notice.svg" className={styles.warning_icon}/>
                      {extraTips.text}
                    </Space>
                  </a>
                </div>
            )}
            <Element name="anchor2" className="element" key="anchor2">
              <p className={styles.job_title}>认证概述</p>
              <div className={styles.item}>
                <Space className={styles.icon_wrapper}>
                  <img src="/img/detail/detail_icon1.png" className={styles.icon} alt=""/>
                  <span className={styles.job_subtitle}>适合人群</span>
                </Space>
                <div className={cx(styles.job_text, styles.job_text_offset)}
                     dangerouslySetInnerHTML={{__html: replaceBr(data?.ability_demanded.suit_people)}}/>
              </div>
              <div className={styles.item}>
                <Space className={styles.icon_wrapper}>
                  <img src="/img/detail/detail_icon2.png" className={styles.icon} alt=""/>
                  <span className={styles.job_subtitle}>认证回报</span>
                </Space>
                <Space size={16} className={styles.job_text_offset}>
                  <Image src={`/img/cert_example/${data.type}.png`} className={styles.img} alt=""/>
                  <div>
                    <div className={cx(styles.job_subtitle, styles.job_secondtitle)}>{data.short_cn_title}证书</div>
                    <p className={styles.job_text}>{data?.ability_demanded.reward}</p>
                  </div>
                </Space>
              </div>
              <div className={styles.item}>
                <div>
                  <Space className={styles.icon_wrapper}>
                    <img src="/img/detail/detail_icon3.png" className={styles.icon} alt=""/>
                    <span className={styles.job_subtitle}>能力要求</span>
                  </Space>
                </div>
                <Space size={data.ability_demanded.url ? 32 : 0} className={styles.job_text_offset}>
                  {data?.ability_demanded && (
                    <>
                      <div>
                        {data.ability_demanded.url &&
                          <img src={data.ability_demanded.url} className={styles.pie_img} alt=""/>}
                      </div>
                      <div>
                        {data.ability_demanded.url && <div className={styles.pie_img_title}>{data.title}</div>}
                        {data.ability_demanded.text.map((text, index) => {
                          if (data.ability_demanded.url) {
                            return (
                              <div key={text}>
                                <Space>
                                  <div className={cx(styles.example_circle, styles[`example${index + 1}`])}/>
                                  <div
                                    className={cx(styles.job_subtitle, styles.job_secondtitle, styles.pie_text)}>{text}</div>
                                </Space>
                              </div>
                            )
                          }
                          return (
                            <div style={{margin: 0}}
                                 className={cx(styles.job_text, styles.job_text_offset)}>{text}</div>
                          )
                        })}
                      </div>
                    </>
                  )}
                </Space>
              </div>
            </Element>
            <Ad ad_data={data?.ad}/>
            <Element name="anchor3" className="element" key="anchor3">
              <Plan data={data}/>
            </Element>
            <Element name="anchor4" className="element" key="anchor4">
              <Data data={data?.document} path_name={data?.short_english_title}/>
            </Element>
            <Element name="anchor5" className="element" key="anchor5">
              <Qa qa={data?.qa}/>
            </Element>
          </div>
        </Media>
        <PhoneComponentWrapper>
          <JobLeftMobile
            data={data}
          />
        </PhoneComponentWrapper>
        <JobList className={cx(styles.job_area_wrapper, isAddExtraHeight && styles.isAddExtraHeight)}
                 type={data?.type}/>
      </div>
    </div>
  )
}
export default Job
